//@flow
import React from 'react';
import {
  makeStyles,
  Typography,
  Checkbox,
  FormControlLabel,
  Divider,
} from '@material-ui/core';
import CustomModal from '../../../../../../../elements/CustomModal/CustomModal';
import CustomButton from '../../../../../../../elements/CustomButton/CustomButton';
import TiendadaCollapse from '../../../../../../../elements/tiendada-collapse';
import {useConversationTags} from '../../../../utils/conversationTag';
import {
  useFilterConversations,
  useFilterConversationsActions,
} from '../../../../utils/conversation';
import {useCollaborators} from '../../../../../../configure/accounts/utils';

import {
  SCHEDULE_MESSAGE_STATE,
  type MessageScheduleState,
} from '../../../../../../../entities';

const useStyles = makeStyles(theme => ({
  modalPaper: {
    width: '100%',
    maxWidth: 500,
    padding: '1rem',
    borderRadius: '1rem',
  },
  root: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '1rem',
    minWidth: 300,
  },
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    textAlign: 'center',
  },
  filterList: {
    display: 'flex',
    flexDirection: 'column',
  },
  footer: {
    display: 'flex',
    gap: '.5rem',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
  },
}));

type Props = {
  open: boolean,
  onClose: () => void,
  onApply: () => void,
};

const MESSAGES_STATES: {
  label: string,
  value: MessageScheduleState,
}[] = [
  {
    label: 'Pendientes',
    value: SCHEDULE_MESSAGE_STATE.PENDING,
  },
  {
    label: 'Enviados',
    value: SCHEDULE_MESSAGE_STATE.SENT,
  },
];

export default function ModalFilter(props: Props) {
  const {onApply, onClose, open} = props;

  const classes = useStyles();

  const {conversationTags} = useConversationTags();
  const {
    filterByTags,
    filterByCollaborator,
    filterByAdmin,
    clearFilters,
    filterByScheduleMessageState,
  } = useFilterConversationsActions();
  const {
    tags,
    collaborators: collaboratorFilter,
    admin,
    scheduleMessageStates,
  } = useFilterConversations();

  const {collaborators} = useCollaborators();

  const toggleAdminFilter = () => {
    filterByAdmin(!admin);
  };

  return (
    <CustomModal
      open={open}
      handleCloseModal={onClose}
      classes={{
        paper: classes.modalPaper,
      }}
    >
      <aside className={classes.root}>
        <header className={classes.header}>
          <Typography className={classes.title}>Filtros</Typography>
        </header>

        <div className={classes.content}>
          <Divider className={classes.divider} />
          <TiendadaCollapse title="Colaborador" startOpen>
            <div className={classes.filterList}>
              <FormControlLabel
                classes={{
                  root: classes.controlLabel,
                  label: classes.greyText,
                }}
                control={
                  <Checkbox
                    onClick={toggleAdminFilter}
                    classes={{root: classes.checkbox}}
                    color="primary"
                    checked={!!admin}
                  />
                }
                label="Administrador"
              />
              {collaborators.map(collaborator => {
                const checked =
                  Array.isArray(collaboratorFilter) &&
                  collaboratorFilter.includes(collaborator.id);

                const handleClick = () => {
                  const prevCollaborators = Array.isArray(collaboratorFilter)
                    ? collaboratorFilter
                    : [];
                  if (checked) {
                    filterByCollaborator(
                      prevCollaborators.filter(c => c !== collaborator.id)
                    );
                  } else {
                    filterByCollaborator([
                      ...prevCollaborators,
                      collaborator.id,
                    ]);
                  }
                };

                return (
                  <FormControlLabel
                    key={collaborator.id}
                    classes={{
                      root: classes.controlLabel,
                      label: classes.greyText,
                    }}
                    control={
                      <Checkbox
                        classes={{root: classes.checkbox}}
                        color="primary"
                        checked={checked}
                        onClick={handleClick}
                      />
                    }
                    label={collaborator.firstName}
                  />
                );
              })}
            </div>
          </TiendadaCollapse>
          <Divider className={classes.divider} />
          <TiendadaCollapse title="Etiqueta" startOpen>
            {conversationTags.length > 0 && (
              <div className={classes.filterList}>
                {conversationTags.map(tag => {
                  const exist = Array.isArray(tags) && tags.includes(tag.id);

                  return (
                    <FormControlLabel
                      key={tag.id}
                      classes={{
                        root: classes.controlLabel,
                        label: classes.greyText,
                      }}
                      control={
                        <Checkbox
                          classes={{root: classes.checkbox}}
                          checked={exist}
                          color="primary"
                          onClick={() => {
                            const prevTags = Array.isArray(tags) ? tags : [];
                            if (exist) {
                              filterByTags(prevTags.filter(t => t !== tag.id));
                            } else {
                              filterByTags([...prevTags, tag.id]);
                            }
                          }}
                        />
                      }
                      label={tag.tag}
                    />
                  );
                })}
                {conversationTags.length === 0 && (
                  <Typography className={classes.greyText}>
                    No hay etiquetas
                  </Typography>
                )}
              </div>
            )}
          </TiendadaCollapse>
          <Divider className={classes.divider} />
          {/*  
          <TiendadaCollapse title="Tareas" startOpen>
            <div className={classes.filterList}>
              <FormControlLabel
                classes={{
                  root: classes.controlLabel,
                  label: classes.greyText,
                }}
                control={
                  <Checkbox
                    classes={{root: classes.checkbox}}
                    color="primary"
                  />
                }
                label="Pendientes"
              />
              <FormControlLabel
                classes={{
                  root: classes.controlLabel,
                  label: classes.greyText,
                }}
                control={
                  <Checkbox
                    classes={{root: classes.checkbox}}
                    color="primary"
                  />
                }
                label="Terminadas"
              />
            </div>
          </TiendadaCollapse>
          <Divider className={classes.divider} />
          */}
          <TiendadaCollapse title="Mensaje Programado" startOpen>
            <div className={classes.filterList}>
              {MESSAGES_STATES.map(messageState => {
                const checked =
                  Array.isArray(scheduleMessageStates) &&
                  scheduleMessageStates.includes(messageState.value);

                const handleClick = () => {
                  const prevStateSelected = Array.isArray(scheduleMessageStates)
                    ? scheduleMessageStates
                    : [];
                  if (checked) {
                    filterByScheduleMessageState(
                      prevStateSelected.filter(c => c !== messageState.value)
                    );
                  } else {
                    filterByScheduleMessageState([
                      ...prevStateSelected,
                      messageState.value,
                    ]);
                  }
                };

                return (
                  <FormControlLabel
                    key={messageState.value}
                    classes={{
                      root: classes.controlLabel,
                      label: classes.greyText,
                    }}
                    control={
                      <Checkbox
                        classes={{root: classes.checkbox}}
                        color="primary"
                        checked={checked}
                        onClick={handleClick}
                      />
                    }
                    label={messageState.label}
                  />
                );
              })}
            </div>
          </TiendadaCollapse>
          <Divider className={classes.divider} />
        </div>

        <footer className={classes.footer}>
          <CustomButton color="primary" onClick={clearFilters} fullWidth>
            Limpiar
          </CustomButton>
          <CustomButton
            variant="contained"
            color="primary"
            onClick={onApply}
            fullWidth
          >
            Cerrar
          </CustomButton>
        </footer>
      </aside>
    </CustomModal>
  );
}
